import Vue from "vue";
import Component from "vue-class-component";
import SupervisorAnalyticsContainer from '@/components/SupervisorAnalyticsContainer/SupervisorAnalyticsContainer'
@Component({
    components: {
        SupervisorAnalyticsContainer,
      }
})
export default class SupervisorAnalytics extends Vue {
    mounted() {}
}